"use client";

import { Instagram, Facebook } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
function FooterNavConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="flex flex-col gap-3">
        {[0, 1, 2, 3].map(i => <li key={i} data-index={i} className="h-5 w-32 bg-muted/40 animate-pulse" />)}
      </ul>;
  }
  return <ul className="flex flex-col gap-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i} className="group/nav">
          <Link to={item.href || "#"} className="text-foreground inline-flex items-center text-[0.9375rem] font-default transition-all duration-200 hover:text-primary">
            <span aria-hidden="true" className="mr-0 inline-block h-1.5 w-1.5 bg-primary opacity-0 -translate-x-2 transition-all duration-200 group-hover/nav:opacity-100 group-hover/nav:translate-x-0 group-hover/nav:mr-3" />
            <span className="transition-all duration-200">{item.label}</span>
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="1630" id="footer-corporativo" className="bg-background text-foreground relative font-default">
      {}
      <div aria-hidden="true" className="absolute top-0 left-0 right-0 h-px" style={{
      background: "linear-gradient(to right, hsla(358, 78%, 50%, 0) 0%, hsla(358, 78%, 50%, 0.7) 50%, hsla(358, 78%, 50%, 0) 100%)"
    }} />

      <div ref={ref} className={`mx-auto max-w-[1440px] px-6 md:px-16 py-24 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
        {}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
          {}
          <div className="md:col-span-5 flex flex-col gap-6">
            <Link to="/" aria-label="Formexa Construction LTD — Home" className="inline-block">
              <WvcLogo className="h-9 w-auto" />
            </Link>

            

            

            {}
            <div aria-hidden="true" className="h-px w-60 mt-2" style={{
            background: "linear-gradient(to right, hsla(358, 78%, 50%, 0.8) 0%, hsla(358, 78%, 50%, 0) 100%)"
          }} />
          </div>

          {}
          <div className="md:col-span-3 flex flex-col gap-5">
            
            <MenuProvider menu_id="17">
              <FooterNavConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="md:col-span-2 flex flex-col gap-5">
            
            <div className="flex items-center gap-5">
              <Link to="#" aria-label="Formexa en Instagram" className="text-foreground transition-colors duration-200 hover:text-primary">
                
              </Link>
              <Link to="#" aria-label="Formexa en Facebook" className="text-foreground transition-colors duration-200 hover:text-primary">
                
              </Link>
            </div>
          </div>

          {}
          <div className="md:col-span-2 flex flex-col gap-5">
            
            <Link to="tel:+12366884639" className="font-default italic text-foreground transition-colors duration-200 hover:text-primary" style={{
            fontSize: "clamp(1.25rem, 1.5vw, 1.5rem)",
            fontWeight: 700,
            letterSpacing: "-0.015em",
            lineHeight: 1.15
          }}>
              +1 236-688-4639
            </Link>
            <Link to="mailto:Formexaconstruction@gmail.com" className="font-mono text-muted-foreground uppercase transition-colors duration-200 break-all !text-justify !italic !underline !w-[130px] !text-[5px] hover:text-primary" style={{
            letterSpacing: "0.14em",
            lineHeight: 1.4
          }}><span className="!text-sm" data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:42fiuy" data-ast-start="4084" data-ast-end="4221">info@formexaconstruction.com</span></Link>

            <Button asChild className="mt-2 self-start bg-primary text-white border border-primary hover:bg-red-700 font-mono uppercase group/btn" style={{
            fontSize: "0.75rem",
            letterSpacing: "0.2em",
            padding: "18px 28px",
            height: "auto"
          }}>
              
            </Button>
          </div>
        </div>

        {}
        <div aria-hidden="true" className="mt-20 h-px w-full" style={{
        background: "linear-gradient(to right, hsla(358, 78%, 50%, 0) 0%, hsla(358, 78%, 50%, 0.5) 50%, hsla(358, 78%, 50%, 0) 100%)"
      }} />

        {}
        <div className="mt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="font-mono text-muted-foreground text-[0.6875rem] uppercase" style={{
          letterSpacing: "0.18em",
          lineHeight: 1
        }}><br /></p>
          
        </div>
      </div>
    </section>;
}